import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IExplorableItemTypeInfo } from '~src/ts/models/resourceInfoParts';
import { IGetItemsParams } from '~src/ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/ts/ServerApi/types/IGetItemsResult';
import { ISiteNameWithId } from '~src/ts/ServerApi/types/ISiteNameWithId';

export interface IResourceGovernanceSiteSetting extends IExplorableItemTypeInfo<'resourceGovernanceSetting'> {
  site: ISiteNameWithId;
  usingDefaultSettings: boolean;
  extractCapacity: number;
  subscriptionCapacity: number;
  flowCapacity: number;
  runtimeLimits: number;
  actualRuntime: number;
}

export interface IGetResourceGovernanceSiteSettingsResult extends IGetItemsResult {
  settings: Omit<IResourceGovernanceSiteSetting, 'contentType'>[];
}

export class GetResourceGovernanceSiteSettingsRequest extends Request<IGetItemsParams, IGetResourceGovernanceSiteSettingsResult> {
  constructor(params: IGetItemsParams) {
    super('getResourceGovernanceSiteSettings', params);
  }
}
